<template>
  <div class="mainContainer" v-loading="loading">
    <div class="nav">
      <el-form :model="searchForm" label-width="130px" :inline="true">
        <el-form-item label="委托商：">
          <el-input v-model="searchForm.consignorName" size="mini" placeholder="请输入委托商" />
        </el-form-item>
        <el-form-item label="供应商：">
          <el-input v-model="searchForm.supplierName" size="mini" placeholder="请输入供应商" />
        </el-form-item>
        <el-form-item label="结算类型：">
          <el-select v-model="searchForm.settlementType" filterable size="mini" placeholder="请选择结算类型">
            <el-option label="全部" value=""></el-option>
            <el-option label="港口" :value="1"></el-option>
            <el-option label="库房" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="港口/库房名称：">
          <el-input v-model="searchForm.name" size="mini" placeholder="请输入港口/库房名称" />
        </el-form-item>
        <el-form-item label="作业类型：">
          <el-select v-model="searchForm.workTypeId" filterable size="mini" placeholder="请选择作业类型">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in taskTypeOptions" :key="item.id" :label="item.workType" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="台账月：">
          <el-input v-model="searchForm.standingBookMonth" size="mini" placeholder="请输入台账月" />
        </el-form-item>
        <el-form-item label="品牌：">
          <el-input v-model="searchForm.brand" size="mini" placeholder="请输入品牌" />
        </el-form-item>
        <el-form-item label="是否生成台账：">
          <el-select v-model="searchForm.isAccount" filterable size="mini" placeholder="请选择是否生成台账">
            <el-option label="全部" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否提交收入调账：" label-width="140px">
          <el-select v-model="searchForm.isAdjust1" filterable size="mini" placeholder="请选择是否提交调账">
            <el-option label="全部" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否提交支出调账：" label-width="140px">
          <el-select v-model="searchForm.isAdjust2" filterable size="mini" placeholder="请选择是否提交调账">
            <el-option label="全部" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对账单编号：">
          <el-input v-model="searchForm.settNo" size="mini" placeholder="请输入对账单编号" />
        </el-form-item>
        <el-form-item label="是否结算出费用：">
          <el-select v-model="searchForm.isSupplierSettlementPrice" filterable size="mini" placeholder="请选择是否结算出费用">
            <el-option label="全部" value=""></el-option>
            <el-option label="已刷新" value="1"></el-option>
            <el-option label="未刷新" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算方式：">
          <el-select v-model="searchForm.settleType" filterable size="mini" placeholder="请选择结算方式">
            <el-option label="全部" value=""></el-option>
            <el-option label="预估" value="1"></el-option>
            <el-option label="合同" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提交台账批次：">
          <el-input v-model="searchForm.submitLedgerNumber" size="mini" placeholder="请输入提交台账批次" />
        </el-form-item>
        <el-form-item label="调整台账批次：">
          <el-input v-model="searchForm.updateLedgerNumber" size="mini" placeholder="请输入调整台账批次" />
        </el-form-item>
        <el-form-item label="作业时间：">
          <el-date-picker
            v-model="searchForm.agtTime"
            value-format="yyyy-MM-dd"
            type="daterange"
            size="mini"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <!-- <el-button size="small" type="primary" @click="refreshAccount">价格刷新</el-button>
          <el-button size="small" type="primary" @click="generateAccount">生成台账</el-button>
          <el-button size="small" type="primary" @click="submitReconciliation">提交调账</el-button>
          <el-button size="small" type="primary" @click="actualSettlementAmountRefresh">实际结算金额刷新</el-button> -->
          <el-button size="small" type="primary" @click="refreshAccount">一次暂估价格刷新</el-button>
          <el-button size="small" type="primary" @click="refreshAccount2">二次暂估价格刷新</el-button>
          <el-button size="small" type="primary" @click="refreshAccount3">三次暂估价格刷新</el-button>
          <el-button size="small" type="primary" @click="generateAccount">一次暂估生成台账</el-button>
          <el-button size="small" type="primary" @click="generateAccount2">二次暂估生成台账</el-button>
          <el-button size="small" type="primary" @click="generateAccount3">三次暂估生成台账</el-button>
          <el-button size="small" type="primary" @click="actualSettlementAmountRefresh">实际结算金额刷新</el-button>
          <el-button size="small" type="primary" @click="submitReconciliation(0)">提交调账</el-button>
          <el-button size="small" type="primary" @click="actualSettlementAmountRefresh1">对账调整金额刷新</el-button>
          <el-button size="small" type="primary" @click="submitReconciliation(1)">对账调整生成台账</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span="24">
        <span class="right font-size-14 pointer" style="color: #3388ff" @click="exportData">导出数据</span>
      </el-col>
    </el-row>
    <div class="content">
      <div class="tableContainer">
        <el-table ref="registerTable" v-loading="tableLoading" :data="tableData" style="width: 100%" border :header-cell-style="headerCellStyle" @selection-change="selectionDataChange" :row-style="rowStyle">
          <el-table-column type="selection" align="center" min-width="80px" />
          <el-table-column prop="consignorName" label="委托商" align="center" min-width="240px" />
          <el-table-column prop="standingBookMonth" label="台账月" align="center" min-width="100px"
            @paste.native.capture.prevent="value => {
              return searchCopyFormat(value, 'standingBookMonth')
            }"
          />
          <el-table-column prop="settlementType" label="结算类型" align="center" min-width="120px" :formatter="settlementTypeFormat" />
          <el-table-column prop="name" label="港口/库房名称" align="center" min-width="200px" />
          <el-table-column prop="brand" label="品牌" align="center" min-width="100px" />
          <el-table-column prop="consignorTaskCount" label="委托商作业数量" align="center" min-width="120px" />
          <el-table-column prop="consignorTaxRate" label="税率(%)" align="center" min-width="100px" />
          <el-table-column prop="consignorTaxPrice" label="一次暂估价" align="center" min-width="180px" />
          <el-table-column prop="consignorTaxPrice2" label="二次暂估差价" align="center" min-width="180px" />
          <el-table-column prop="consignorTaxPrice3" label="三次暂估差价" align="center" min-width="180px" />
          <el-table-column prop="consignorSettlementPrice" label="实际结算费用" align="center" min-width="100px" />
          <el-table-column prop="consignorPriceDifference" label="差价" align="center" min-width="100px" />
          <el-table-column prop="consignorPriceAdjust" label="对账调整差价" align="center" min-width="180px" />
          <el-table-column prop="isAdjust1" label="是否提交收入调账" align="center" min-width="130px">
            <template slot-scope="scope">
              {{ scope.row.isAdjust1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column label="是否生成收入对账单" align="center" min-width="140px">
            <template slot-scope="scope">
              {{ scope.row.srDzdNo ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="srDzdNo" label="收入对账单编号" align="center" min-width="140px" />
          <el-table-column prop="srTz1No" label="一次台账编号" align="center" min-width="140px" />
          <el-table-column prop="srTz2No" label="收入调账编号" align="center" min-width="140px" />
          <el-table-column prop="srDztzNo" label="对账调整台账编号" align="center" min-width="140px" />
          <el-table-column prop="supplierName" label="供应商" align="center" min-width="180px" />
          <el-table-column prop="workType" label="作业类型" align="center" min-width="100px" />
          <el-table-column prop="taskDate" label="作业时间" align="center" min-width="100px" />
          <el-table-column prop="supplierTaskCount" label="供应商作业数量" align="center" min-width="120px" />
          <el-table-column prop="supplierTaxRate" label="税率(%)" align="center" min-width="100px" />
          <el-table-column prop="supplierTaxPrice" label="一次暂估价" align="center" min-width="100px" />
          <el-table-column prop="supplierTaxPrice2" label="二次暂估差价" align="center" min-width="100px" />
          <el-table-column prop="supplierTaxPrice3" label="三次暂估差价" align="center" min-width="100px" />
          <el-table-column prop="supplierSettlementPrice" label="实际结算含税费用" align="center" min-width="130px" />
          <el-table-column prop="supplierPriceDifference" label="差价" align="center" min-width="100px" />
          <el-table-column prop="supplierPriceAdjust" label="对账调整差价" align="center" min-width="100px" />
          <el-table-column prop="isAdjust2" label="是否提交支出调账" align="center" min-width="130px">
            <template slot-scope="scope">
              {{ scope.row.isAdjust2 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="isAccount" label="是否生成台账" align="center" min-width="100px">
            <template slot-scope="scope">
              {{ scope.row.isAccount ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column label="是否生成支出对账单" align="center" min-width="140px">
            <template slot-scope="scope">
              {{ scope.row.zcDzdNo ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="zcDzdNo" label="支出对账单编号" align="center" min-width="140px" />
          <el-table-column prop="zcTz1No" label="一次台账编号" align="center" min-width="140px" />
          <el-table-column prop="tzNo2" label="二次台账编号" align="center" min-width="140px" />
          <el-table-column prop="tzNo3" label="三次台账编号" align="center" min-width="140px" />
          <el-table-column prop="zcDztzNo" label="对账调整台账编号" align="center" min-width="140px" />
          <el-table-column prop="zcTz2No" label="支出调账编号" align="center" min-width="140px" />
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" :current-page.sync="searchForm.page" :page-size="searchForm.rows" />
      </div>
    </div>
    <el-dialog :title="dialogAccoutTitle" :visible.sync="dialogAccoutVisible" width="450px" center top="10vh" @close="dialogAccoutClose" :close-on-click-modal="false">
      <div class="btnContainer">
        <el-radio-group v-model="submitType">
          <el-radio label="0">收入</el-radio>
          <el-radio label="1">支出</el-radio>
          <!--          <el-radio label="2">收入/支出</el-radio>-->
        </el-radio-group>
      </div>
      <div class="btnContainer">
        <el-button size="medium" class="searchBtn" @click="submit" :loading="submitLoading">确认</el-button>
        <el-button size="medium" class="resetBtn" @click="cancel">取消</el-button>
      </div>
    </el-dialog>

    <account-and-reconciliation ref="accountAndReconciliation" @getTableData="getTableData" />
  </div>
</template>

<script>
  import AccountAndReconciliation from '@/views/settle/accountManagement/accountDetails/components/accountAndReconciliation';
  import { getAccountDetail, getAccountList, refreshAccountList, flashStandingBookPrice, getAccountDetail2, getAccountDetail3, flashAdjustPrice, submit2 } from '@/service/account';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import { getTaskType, portWarehouseLedgerGenerate, portWarehouseLedgerList, portWarehouseLedgerRefresh, generateAccountByDifferenceBatch, portWarehouseLedgerRefresh2, portWarehouseLedgerRefresh3 } from '@/service/warehouse';

  export default {
    name: 'accountDetails',
    components: { AccountAndReconciliation },
    data() {
      return {
        submitReconciliationType: '',
        loading: false,
        searchForm: {
          settNo: '', // 对账单编号
          isSupplierSettlementPrice: '', // 是否结算出费用
          settleType: '',// 结算方式
          submitLedgerNumber: '',// 提交台账批次
          updateLedgerNumber: '',// 调整台账批次
          agtTime: ['', ''],// 作业时间 - 开始时间 and 结束时间 - startDate endDate
          waybillNo: '',
          frameNumber: '',
          consignorName: '',
          supplierName: '',
          standingBookMonth: '',
          isAdjust1: '',
          isAdjust2: '',
          brandName: '',
          typeStr: [],
          isContactPrice: '',
          page: 1,
          rows: 10,
        },
        taskTypeOptions: [],
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        total: 0,
        checkTableData: [],
        dialogAccoutTitle: '提交对账',
        dialogAccoutVisible: false,
        submitLoading: false,
        submitType: '',
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      //  this.searchBtn();
      this.getTaskType();
    },
    methods: {
      async actualSettlementAmountRefresh() {
        const {status, message, data} = await flashStandingBookPrice();
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
      },
      async actualSettlementAmountRefresh1() {
        const {status, message, data} = await flashAdjustPrice();
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
      },
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text').replace(/\s/g, ',').split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        this.searchForm[flag] = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
        // switch (flag) {
        //   case 'frameNumber':
        //     this.searchForm.frameNumber = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
        //     break;
        //   case 'standingBookMonthStr':
        //     this.searchForm.standingBookMonthStr = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
        //     break;
        // }
      },
      async getTaskType() {
        const { status, message, data } = await getTaskType();
        if (status !== 0) return this.$message.warning(message);
        this.taskTypeOptions = [...data['warehouseWork'], ...data['portWork']];
        console.log(this.taskTypeOptions);
      },
      settlementTypeFormat(r, c, cellValue) {
        switch (cellValue) {
          case 1:
            return '港口';
          case 0:
            return '库房';
        }
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 刷新台账
      async refreshAccount() {
        this.loading = true;
        const { status, message } = await portWarehouseLedgerRefresh();
        this.loading = false;
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        await this.resetBtn();
        await this.getTableData();
      },
      async refreshAccount2() {
        if (this.checkTableData.length>0) {
          this.loading = true;
          const { status, message } = await portWarehouseLedgerRefresh2({
            consignorName: this.checkTableData[0].consignorName,
            supplierName: this.checkTableData[0].supplierName,
            consignorId: this.checkTableData[0].consignorId,
            supplierId: this.checkTableData[0].supplierId,
            id: this.checkTableData.map(item => item.id).join(','),
          });
          this.loading = false;
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          await this.resetBtn();
          await this.getTableData();
        } else {
          this.$message.warning("请先选择数据！");
        }

      },
      async refreshAccount3() {
        if (this.checkTableData.length>0) {
          this.loading = true;
          const { status, message } = await portWarehouseLedgerRefresh3({
            consignorName: this.checkTableData[0].consignorName,
            supplierName: this.checkTableData[0].supplierName,
            consignorId: this.checkTableData[0].consignorId,
            supplierId: this.checkTableData[0].supplierId,
            id: this.checkTableData.map(item => item.id).join(','),
          });
          this.loading = false;
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          await this.resetBtn();
          await this.getTableData();
        } else {
          this.$message.warning("请先选择数据！");
        }
      },
      // 生成台账
      async generateAccount() {
        const { status, message } = await getAccountDetail(this.searchForm);
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        await this.getTableData();
        // this.tableData = data.records;
        // this.total = data.total;
        // if (this.$refs.registerTable.selection.length === 0) return this.$message.warning('请选择数据后生成台账');
        // const ids = [];
        // let flag = true;
        // this.$refs.registerTable.selection.forEach(item => {
        //   if (item.isAccount === 1) {
        //     flag = false;
        //   }
        //   ids.push(item.id);
        // });
        // if (flag) {
        //   this.$refs.accountAndReconciliation.dialogOpen({
        //     name: '生成台账',
        //     ids,
        //   });
        // } else {
        //   return this.$message.warning('已选择生成台账数据，不可重复生成');
        // }
      },
      async generateAccount2() {
        const { status, message} = await getAccountDetail2(this.searchForm);
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        await this.getTableData();
      },
      async generateAccount3() {
        const { status, message } = await getAccountDetail3(this.searchForm);
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        await this.getTableData();
      },
      // 提交调账
      submitReconciliation(type) {
        this.submitReconciliationType =type;
        // if (this.$refs.registerTable.selection.length === 0) return this.$message.warning('请选择数据后提交调账');
        // const ids = [],
        //   tipStrArr = [];
        // let tipFlag = true,
        //   tipStr = '';
        // this.$refs.registerTable.selection.forEach((item, index) => {
        //   if (item.taxPriceDiffer === null || item.zxPriceDiffer === null || item.taxPriceDiffer2 === null) {
        //     tipFlag = false;
        //     tipStrArr.push(item.frameNumber);
        //   }
        //   ids.push(item.id);
        // });
        // if (tipFlag) {
        //   this.$refs.accountAndReconciliation.dialogOpen({
        //     name: '提交调账',
        //     ids: ids,
        //   });
        // } else {
        //   tipStrArr.forEach((item, index) => {
        //     if (index + 1 === tipStrArr.length) {
        //       tipStr += item;
        //     } else {
        //       (index + 1) % 2 === 0 ? tipStr += item + ',' : tipStr += item + ',\n';
        //     }
        //     console.log(tipStr, index, tipStrArr.length);
        //   });
        //   return this.$message.warning('供应商：' + tipStr + '差额为空无法提交调账');
        // }
        this.dialogAccoutVisible = true;
      },
      //确认
      async submit() {
        // console.log('<<<');
        this.submitLoading = true;
        this.searchForm.submitType = this.submitType;

        try {
          if (this.submitReconciliationType == 0) {
            const { status, message } = await generateAccountByDifferenceBatch({
              submitType: this.submitType,
              standingBookMonth: this.searchForm.standingBookMonth,
            });
            if (status !== 0) {
              this.$message.warning(message);
              this.submitLoading = false;
              return;
            }
            this.$message.success(message);
            this.submitLoading = false;
            this.dialogAccoutClose();
          } else {

            const { status, message } = await submit2({
              submitType2: this.submitType,
              standingBookMonth: this.searchForm.standingBookMonth,
            });
            if (status !== 0) {
              this.$message.warning(message);
              this.submitLoading = false;
              return;
            }
            this.$message.success(message);
            this.submitLoading = false;
            this.dialogAccoutClose();
          }

        } catch (error) {
          this.$message.error(error);
          this.submitLoading = false;
        }
      },
      //取消
      cancel() {
        this.dialogAccoutVisible = false;
        this.submitType = '';
      },
      dialogAccoutClose() {
        this.dialogAccoutVisible = false;
        this.submitType = '';
      },

      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const { data, status, message } = await portWarehouseLedgerList({...this.searchForm, startDate: this.searchForm.agtTime[0], endDate: this.searchForm.agtTime[1]});
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      selectionDataChange(selection) {
        this.checkTableData = selection;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      // 导出数据
      exportData() {
        let token = getSessionStore('token');
        window.exportExcel(`${baseUrl}/platform/settlement/portAndWarehouse/export?access_token=${token}`, {...this.searchForm, startDate: this.searchForm.agtTime[0], endDate: this.searchForm.agtTime[1]}, '港口库房台账');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;
    background-color: #fff;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
  }
</style>
